import { useQueryExternalBankAccountConfigs } from '../../models/useQueryExternalBankAccountConfigs'

export const useExternalBankAccountConfigListPresenter = () => {
  const { accounts, pagination, isFetching, isError } =
    useQueryExternalBankAccountConfigs()

  return {
    data: {
      accounts,
      pagination,
    },
    states: {
      isFetching,
      isError,
    },
  }
}
